import { render, staticRenderFns } from "./teamagent.vue?vue&type=template&id=47dec5a4&scoped=true"
import script from "./teamagent.vue?vue&type=script&lang=js"
export * from "./teamagent.vue?vue&type=script&lang=js"
import style0 from "./teamagent.vue?vue&type=style&index=0&id=47dec5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dec5a4",
  null
  
)

export default component.exports